
        import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/node_modules/ui-core/plugins/panzoom/jquery.panzoom';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/node_modules/ui-core/components/figure-viewer/js/figure-viewer-script';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/widgets/publication-content/js/publication-content';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/node_modules/ui-core/widgets/publication-content/js/crossref';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/node_modules/ui-core/widgets/article-tools/js/article-tools';
  
const main = (UX) => {
    const $figureViewer = Array.prototype.slice.call(document.querySelectorAll('figure:not(.holder), .figure:not(.holder),.colored-block,.component-container')),
        $loader = Array.prototype.slice.call(document.querySelectorAll('article'))

try {
        if ($figureViewer.length ) {
            UX.figureViewer.init($figureViewer);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($loader.length ) {
            UX.loader.init($loader);
        }
    } catch (err) {
        console.error(err);
    }
    
}

        export default main;
        